function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import ListingType from '@domain-group/fe-allhomes-library/lib/enums/listing-type';

/* For testing in development demo */
/*
(function loadScript(url, callback) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.onload = callback;
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}('//secure-au.imrworldwide.com/v60.js', () => {
  const userAgent = window.navigator.userAgent;
  if (userAgent === undefined || userAgent.indexOf('ahmob|') === -1) {
    const pvar = { cid: 'allhomes', content: '0', server: 'secure-gl' };
    window.trac = window.nol_t(pvar);
    window.trac.record().post();
  }
}));
*/
import { jsx as ___EmotionJSX } from "@emotion/core";
var allhomesNielsenWrapper = BaseListingDetails => {
  class AllhomesNielsenWrapper extends React.Component {
    constructor(props) {
      var _this;
      super(props);
      _this = this;
      _defineProperty(this, "onGalleryEvent", function (options) {
        _this.emitNielsenEvent(options.image);
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        _this.props.onGalleryEvent(options, ...args);
      });
      _defineProperty(this, "onPreviewImageLeft", function (index, src, image) {
        _this.emitNielsenEvent(image);
        for (var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          args[_key2 - 3] = arguments[_key2];
        }
        _this.props.onPreviewImageLeft(index, src, image, ...args);
      });
      _defineProperty(this, "onPreviewImageRight", function (index, src, image) {
        _this.emitNielsenEvent(image);
        for (var _len3 = arguments.length, args = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
          args[_key3 - 3] = arguments[_key3];
        }
        _this.props.onPreviewImageRight(index, src, image, ...args);
      });
      _defineProperty(this, "emitNielsenEvent", image => {
        if (typeof window.trac !== 'undefined' && typeof window.trac.slideEvent === 'function') {
          var listingCategory = ListingType[this.props.listingType].category;
          var suffix = '';
          if (image.id) {
            suffix = "-".concat(image.id);
          }
          window.trac.slideEvent("allhomes:photogallery:".concat(listingCategory).concat(suffix));
        }
      });
      this.emitNielsenEvent = this.emitNielsenEvent.bind(this);
      this.onGalleryEvent = this.onGalleryEvent.bind(this);
      this.onPreviewImageLeft = this.onPreviewImageLeft.bind(this);
      this.onPreviewImageRight = this.onPreviewImageRight.bind(this);
    }
    render() {
      var props = _objectSpread(_objectSpread({}, this.props), {}, {
        onGalleryEvent: this.onGalleryEvent,
        onPreviewImageLeft: this.onPreviewImageLeft,
        onPreviewImageRight: this.onPreviewImageRight
      });
      return ___EmotionJSX(BaseListingDetails, props);
    }
  }
  AllhomesNielsenWrapper.propTypes = {
    listingType: PropTypes.string.isRequired,
    onGalleryEvent: PropTypes.func,
    onPreviewImageLeft: PropTypes.func,
    onPreviewImageRight: PropTypes.func
  };
  AllhomesNielsenWrapper.defaultProps = {
    onGalleryEvent: () => {},
    onPreviewImageLeft: () => {},
    onPreviewImageRight: () => {}
  };
  setHOCDisplayName(AllhomesNielsenWrapper, BaseListingDetails, 'AllhomesNielsenWrapper');
  return AllhomesNielsenWrapper;
};
export default allhomesNielsenWrapper;